import { FAQ } from '../page-components/common/FAQ';
import Connection from '../connection/Connection';

export default FAQ;
// Test
export const getServerSideProps = async () => {
  const connection = Connection.nextConnectionNoAuth();
  try {
    const data = await connection.get('faq', { active: true });
    return { props: { data } };
  } catch (e) {
    return {
      props: {},
    };
  }
};
